import { NgModule ,CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { NglMenusModule , NglDropdown  } from 'ng-lightning';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import { RouterModule } from '@angular/router';

import { RiHeaderComponent } from './ri-header.component';
import { IdleTimeoutService } from '../core/idle-timeout.service';

@NgModule({
  declarations: [
    RiHeaderComponent
  ],

  imports: [
    CommonModule
    ,RouterModule
    ,BrowserAnimationsModule
    ,ButtonsModule
    ,NglMenusModule
    ,DropDownsModule
 ],
 providers: [
  IdleTimeoutService
 ],
  exports: [
      NglDropdown
      ,RiHeaderComponent
],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ],
})
export class RiHeaderModule { }
